export default {
  Role: "Role",
  action: "action",
  activation_date: "Activation date",
  active: "active",
  add: "add",
  addAlbumName: "add album name",
  addSelectedToClaimList: "Add to Claim Workspace",
  addedToClaimList: "Added to Claim List",
  additional_data: "additional data",
  additions_pct: "Additions percentage",
  address: "address",
  agent: "agent",
  airdatetime: "airdatetime",
  all_fields_must_be_filled: "All Fields must be filled!",
  artist: "artist",
  auto_manually_matched: "auto manually matched",
  automatched: "automatched",
  automatchedCheckboxInfo: "Select this to re-match the already matched usages as well (manual matches won’t be re-matched).",
  blocked: "blocked",
  cancel: "cancel",
  chooseFileOrDrag: "choose a file or drag it here",
  choose_mandates_before_activation: "Please choose mandates before activating user",
  claim: "claim",
  claimAll: "claim all",
  claimPercentage: "claim %",
  claimStatus: "claim status",
  claimWorkspace: "Claim Workspace",
  claim_edited: "Claim Edited",
  claimed: "claimed",
  claiming: "claiming",
  claims: "claims",
  clear: "clear",
  clearFilters: "clear filters",
  clear_all: "clear all",
  collapse: "collapse",
  companyName: "company name",
  company_profile: "company profile",
  confirm_finalize_distribution: "Please note that finalising the distribution will publish the individual distribution reports to your members and you will no longer be able to change them. Would you like to proceed?",
  confirm_validate: "confirm validate",
  congratulations: "congratulations",
  continue: "continue",
  create: "create",
  createNewSoundRecording: "create new sound recording",
  createPlaceholder: "create placeholder",
  create_user: "Create user",
  create_user_for: "Create user for",
  created: "created",
  date: "date",
  deduction_pct: "deduction %",
  defaultMatchingInfo: "By default, only the unmatched usages will be matched again.",
  delete: "delete",
  deleteClaims: "batch delete claims",
  delete_distribution: "Delete Distribution",
  delete_distribution_warning: "Are you sure you want to delete this distribution draft?",
  deleted: "deleted",
  dismiss: "dismiss",
  distribution: "distribution",
  distribution_deleted: "distribution deleted",
  distribution_saved: "Distribution saved",
  distributions: "distributions",
  domestic: "domestic",
  download: "download",
  downloadFile: "download file",
  downloadSampleFile: "download sample file",
  downloadSampleFileNote: "NOTE: Sample file depend on the use type selected, previously downloaded files could not work",
  downloadTemplate: "download template",
  duration: "duration",
  editClaim: "edit claim",
  editClaims: "batch edit claims",
  editDistribution: "edit distribution",
  editDistributionForFile: "Edit distribution for fund file:",
  edit_org: "edit company profile",
  email: "email",
  email_format_not_valid: "email has not a valid format",
  email_not_defined: "email is not defined",
  email_sent: "Email sent",
  error: "error",
  errors: "Errors",
  exclude_members: "Exclude Members",
  exclude_members_modal_header: "Exclude Members from Fund",
  exclude_members_modal_sub_text: "Normally SoundSys distributes to all members with a valid mandate. If certain members have direct licenses or shouldn't participate in this fund, you can exclude them here. Selected members will be excluded from this fund's distribution.",
  expired_session: "Your session has expired! Please login",
  extras: "extras",
  field: "Field",
  fileName: "file name",
  fileType: "file type",
  file_uploaded: "File uploaded!",
  filterFiles: "filter files",
  filterSoundRecordings: "filter sound recordings",
  filterTimePeriod: "filter time period",
  filters: "filters",
  finishSetup: "finish setup",
  fixation_country: "Country of Recording",
  fixation_year: "Year of recording",
  forgot_your_password: "Forgot your password?",
  from: "from",
  funds: "funds",
  generatePreDistributionReport: "generate pre distribution report",
  generateUnmatchedReport: "generate unmatched report",
  generatedReportWillBeSent: "generated report will be sent to you via email",
  genres: "genres",
  go_back: "go back",
  go_to_users: "go to users",
  gross_amount: "Gross amount",
  hide: "hide",
  history: "history",
  ingested: "ingested",
  ingestionStats: "Ingestion Stats",
  invalid_data_range: "Invalid date range",
  invalid_split_range: "The split value should be in the range 0-100",
  invalid_split_value: "Invalid split value",
  invalid_time_format: "Invalid time format",
  invalidateSource: "invalidate source",
  invalidateSourceInfo: "Warning. You are removing this instance data. It will no longer appear in the UI.",
  invalidatedSource: "source invalidated",
  isEligible: "is eligible",
  isrc: "ISRC",
  item: "Item",
  landed: "landed",
  landed_sound_recordings: "landed sound recordings",
  lang_of_perf: "Language of performance",
  language: "language",
  licensee: "licensee",
  linked: "linked",
  log_in: "log in",
  login: "login",
  logout: "logout",
  makeAClaim: "make a claim",
  manually_created: "manually created",
  manually_linked: "manually linked",
  manually_matched: "manually matched",
  match: "match",
  matched: "matched",
  matchingStats: "Matching Stats",
  member: "member",
  memberProfile: "member profile",
  memberSociety: "Member / Society",
  member_not_defined: "organization member is not defined",
  member_saved: "Member saved",
  members: "members",
  missing_required_fields: "Missing required fields",
  myProfile: "my profile",
  name: "name",
  name_and_last_name: "first & last name",
  name_and_last_name_not_defined: "name and lastname are not defined",
  nationality: "nationality",
  net_amount: "Net Amount",
  newDistribution: "new distribution",
  new_member_signup: "new member sign up",
  no: "no",
  nothingToAdd: "Nothing to add",
  notifications: "notifications",
  num_users: "No of Users",
  optional: "optional",
  orSelectCustomDateRange: "Or select custom date range",
  organization: "organization",
  other_deductions_pct: "Other deductions percentage",
  overclaimed: "overclaimed",
  password: "password",
  password_recovery: "Password recovery",
  payee: "payee",
  pending: "pending",
  pending_for_validation: "pending for validation",
  people: "people",
  period: "period",
  placeholderSoundRecording: "This is a sound recording created from a usage log.",
  play_count: "play count",
  playlist_not_found: "Playlist file not found",
  playlist_rematching: "Playlist files re-matching",
  playlist_rematching_check: "Select this to re-match all playlist files included in this distribution.",
  playlist_rematching_desc: "By default the distribution engine will use current matching on all selected playlist files.",
  playlist_set_allocable: "Playlist Set Allocable",
  playlist_will_be_matched_again: "Playlist will be matched again",
  playlists: "playlists",
  please_indicate_a_recovery_email: "Please indicate a recovery email",
  preDistributionWarning: "Only duration based playlist will be used for the pre-distribution report",
  processing: "processing",
  proposedCandidates: "proposed candidates",
  proprietary_id: "Proprietary ID / Uploaded By",
  provider_id: "Provider id",
  re_allocate: "re-allocate",
  readyForDistribution: "Ready for distribution",
  reason: "Reason",
  recording_unclaimed: "Recording Unclaimed",
  regitry_line_1: "Your application will be reviewed.",
  regitry_line_2: "Once it’s approved you’ll receive en email to set up your password",
  regitry_line_3: "stay tuned!",
  regitry_line_4: "You should hear from us shortly!",
  releaseNames: "album names",
  remove: "remove",
  removeAllClaimsQuestion: "Do you want to remove all sound recordings from the claim list?",
  removeClaim: "remove claim",
  remove_all: "remove all",
  repertoire: "repertoire",
  rightOwner: "right Owner",
  rightOwners: "right owners",
  rightPeriod: "right period",
  rightTypes: "right types",
  rights: "rights",
  rule: "rule",
  save: "save",
  saveAsDraft: "save as draft",
  save_member: "Save Member",
  save_member_warning: "Warning: Changing the mandates/use-types for this member will update existing claims. These changes can take a few hours to be reflected on the database. Are you sure?",
  search: "search",
  search_candidates: "search candidates",
  select: "select",
  selectFileType: "Select File Type",
  selectFunds: "select funds",
  selectMember: "Select member",
  selectPayee: "select payee",
  selectPlaylists: "select playlists",
  selectRightOwner: "select right owner",
  selectRightTypes: "select right types",
  selectRule: "select rule",
  selectStatus: "select status",
  selectUseType: "select use type",
  select_all: "select all",
  select_date: "select date",
  select_date_range: "select date range",
  select_member: "select a member",
  select_members: "Select members",
  select_members_to_participate: "Select members to participate",
  select_type: "select a type",
  send: "Send",
  send_notifications: "send notifications",
  setupNewDistribution: "setup new distribution",
  show: "show",
  showIneligible: "Show ineligible",
  show_hidden: "show hidden",
  show_inactive: "Show inactive",
  sign_up: "sign up",
  signup_header: "Fill out your details. The account will be reviewed before created",
  society: "society",
  soundRecordingDetail: "sound recording detail",
  soundRecordingDetails: "sound recording details",
  soundRecordings: "sound recordings",
  soundSysDatabase: "SoundSys Database",
  sound_recording_saved: "Sound Recording Saved!",
  sound_recordings_claimed: "Sound Recordings Claimed",
  soundrecordingDetail: "soundrecording detail",
  source: "source",
  sourceMetadata: "source metadata",
  split: "split",
  status: "status",
  submittedBy: "submitted by",
  tax_deductions_pct: "Tax deduction percentage",
  this_user_will_receive_all_notifications: "this user will receive all notifications",
  this_user_will_receive_no_notifications: "this user will receive no notifications",
  time_period: "time period",
  title: "title",
  to: "to",
  total: "total",
  total_unique: "total unique",
  type: "type",
  un_select_all: "Un/Select All",
  unclaimed: "unclaimed",
  underclaimed: "underclaimed",
  unmatched: "unmatched",
  unmatched_no_duplicates: "unmatched no duplicates",
  unmatched_ready_for_distribution: "unmatched ready for distribution",
  upload: "upload",
  uploadDate: "upload date",
  uploadFunds: "upload funds",
  uploadProRataFile: "upload pro rata file",
  uploads: "uploads",
  usageType: "Usage type",
  usages: "usages",
  useReleaseMatchingInfo: "Force using Album info while matching. WARNING: This could create false positives",
  useType: "use type",
  userProfile: "User Profile",
  user_data: "User data",
  user_saved: "User saved",
  user_type_not_defined: "user type is not defined",
  username: "username",
  users: "users",
  validate: "validate",
  value: "value",
  version: "version",
  versionTitle: "version title",
  view: "view",
  view_excluded_members: "View Excluded Members",
  view_selected_members: "view selected members",
  view_selected_playlists: "view selected playlists",
  worldwide: "worldwide",
  year: "Year",
  yes: "yes",
}
